import { Map } from 'immutable';
import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';

import Api from '../api';

import Cause from './model';
import { addMultipleAction, addAction, updateAction, removeAction } from './actions';

export default class CauseApi {
  static fetchAll() {
    return Api.get('api/causes').map((causes) =>
      addMultipleAction(Map(causes.map((cause) => [cause.id, new Cause(cause)])))
    );
  }

  static fetch(id) {
    return Api.get(`api/causes/${id}`).map((cause) => addAction(new Cause(cause)));
  }

  static fetchCategories() {
    return Api.get<Cause[]>('api/causes/categories');
  }

  static create(data) {
    return Api.post('api/causes', data).map((cause) => addAction(new Cause(cause)));
  }

  static update(id, data) {
    return Api.patch(`api/causes/${id}`, data).map((cause) => updateAction(new Cause(cause)));
  }

  static delete(id) {
    return Api.delete(`api/causes/${id}`).map(() => removeAction(id));
  }
}

let categoriesCache: Promise<Cause[]> | null = null;
const fetchCategories = () => {
  if (categoriesCache) {
    return categoriesCache;
  }
  categoriesCache = CauseApi.fetchCategories().toPromise();
  return categoriesCache;
};

export const useCategories = (): Cause[] => {
  const [causes, setCategories] = useState<Cause[]>([]);
  useEffect(() => {
    let isCancelled = false;
    fetchCategories()
      .then((data) => {
        if (!isCancelled) {
          setCategories(data);
        }
      })
      .catch((error) => {
        Sentry.captureException(error, { level: 'error' });
      });
    return () => {
      isCancelled = true;
    };
  }, []);
  return causes;
};
